define(["dojo-proxy-loader?name=dojo/_base/kernel!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "./text"], function (dojo) {
  // module:
  //		dojo/cache

  // dojo.cache is defined in dojo/text
  return dojo.cache;
});